<section id="add-corr-container">
  <app-header title="Add Correspondence"></app-header>
  <!-- Add New Correspondence Form -->
  <div class="container">
    <form [formGroup]="myForm" (ngSubmit)="onsubmit()">
      <section class="info-box">
        <h1 class="info-box-heading">Correspondence Details</h1>
        <div class="info-box-wrapper">
          <fieldset class="info-box-body correspondence-details">
            <!-- details -->
            <div class="corr-details info-box-sections flex-row">
              <!-- in/out, priority, category -->
              <div class="info-section flex-align-center-center info-col-3">
                <div></div>
                <mat-form-field appearance="outline">
                  <mat-select placeholder="In/Out &#42;" formControlName="Type">
                    <mat-option value="Incoming">Incoming</mat-option>
                    <mat-option value="Outgoing">Outgoing</mat-option>
                  </mat-select>
                  @if (showRequiredError(['Type'])) {
                    <mat-hint class="hint-class">
                      Please specify Incoming or Outgoing correspondence.
                    </mat-hint>
                  }
                </mat-form-field>
              </div>
              <div class="info-section flex-align-center-center info-col-3">
                <div></div>
                <mat-form-field appearance="outline">
                  <mat-select
                    placeholder="Priority &#42;"
                    formControlName="Priority">
                    @for (p of priorities; track p) {
                      <mat-option [value]="p">{{ p }}</mat-option>
                    }
                  </mat-select>
                  @if (showRequiredError(['Priority'])) {
                    <mat-hint class="hint-class">
                      Please specify the correspondence priority.
                    </mat-hint>
                  }
                </mat-form-field>
              </div>
              <div class="info-section flex-align-center-center info-col-3">
                <label for="Category">Category &#42;</label>
                <div>
                  <select multiple formControlName="Category" id="Category">
                    @for (cat of categories; track cat) {
                      <option [value]="cat.Id">{{ cat.Name }}</option>
                    }
                  </select>
                  @if (showRequiredError(['Category'])) {
                    <mat-hint class="hint-class">
                      Please select categories for this correspondence.
                    </mat-hint>
                  }
                </div>
              </div>
            </div>
            <!-- dates -->
            @if (myForm.controls['Type'].value === 'Incoming') {
              <div class="corr-details info-box-sections flex-row">
                <div class="info-section flex-align-center-center">
                  <mat-form-field appearance="outline" class="add-cor-dates">
                    <mat-label for="date-received">
                      Received Through
                    </mat-label>

                    <mat-select
                      placeholder="Received Through &#42;"
                      formControlName="ReceivedThrough"
                      label="Received Through &#42;"
                      class="mat-control"
                      id="received-through"
                    >
                      @for (r of receivedThrough; track r) {
                        <mat-option [value]="r">{{ r }}</mat-option>
                      }
                    </mat-select>
                    @if (showRequiredError(['ReceivedThrough'])) {
                      <mat-hint class="hint-class">
                        Please specify received method.
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
                <div class="info-section input flex-align-center-center">
                  <mat-form-field appearance="outline" class="add-cor-dates">
                    <mat-label for="date-received">
                      Date Received
                    </mat-label>
                      <input
                        matInput
                        type="date"
                        placeholder="Date Received &#42;"
                        formControlName="DateReceived"
                        class="mat-control"
                        id="date-received"
                      />

                    @if (showRequiredError(['DateReceived'])) {
                      <mat-hint class="hint-class">
                        Please specify when this correspondence was received.
                      </mat-hint>
                    }
                    @if (
                      showCustomError(['DateReceived'], 'beforeTomorrow') ===
                      true
                    ) {
                      <mat-hint class="hint-class">
                        The date received must be today or in the past.
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
                <div class="info-section input flex-align-center-center">
                  <mat-form-field
                    appearance="outline"
                    class="add-cor-dates"
                  >
                    <mat-label for="due-date">
                      Due Date
                    </mat-label>

                    <input
                        matInput
                        type="date"
                        placeholder="Due Date &#42;"
                        formControlName="DueDate"
                        class="mat-control"
                        id="due-date"
                      />

                    @if (showRequiredError(['DueDate'])) {
                      <mat-hint>
                        Please specify when a response is due.
                      </mat-hint>
                    }
                    @if (showCustomError(['DueDate'], 'afterToday')) {
                      <mat-hint class="hint-class">
                        The due date must be sometime after today.
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
            <div fxLayout="row">
              @if (myForm?.errors?.datesRequired) {
                <mat-hint class="hint-class">
                  You must enter the above fields when In/Out type is Incoming.
                </mat-hint>
              }
            </div>
          </fieldset>
        </div>
      </section>
      <section class="info-box" formGroupName="NewRequestor">
        <h1 class="info-box-heading">Contact Details</h1>
        <div class="info-box-wrapper">
          <fieldset class="info-box-body">
            <!-- name -->
            <div class="form-field-container flex-row">
              <mat-form-field class="margin-right" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="First Name"
                  formControlName="FirstName" />
              </mat-form-field>
              <mat-form-field class="margin-right" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Middle Name"
                  formControlName="MiddleName" />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Last Name"
                  formControlName="LastName" />
              </mat-form-field>
            </div>
            <!-- details -->
            <div class="form-field-container flex-column">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Requestor Details"
                  formControlName="Details" />
              </mat-form-field>
            </div>
            <!-- address -->
            <div class="form-field-container flex-column">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Address"
                  formControlName="Address" />
              </mat-form-field>
            </div>
            <div class="form-field-container flex-row">
              <mat-form-field class="margin-right" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="City"
                  formControlName="City" />
              </mat-form-field>
              <!-- PLACEHOLDER STATE FORM FIELD -->
              <mat-form-field class="margin-right" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="State"
                  formControlName="State" />
              </mat-form-field>
              <!-- PLACEHOLDER STATE FORM FIELD -->
              <!--<mat-form-field class="margin-right">
                <input matInput type="text" placeholder="State" [matAutocomplete]='stateAuto' formControlName='State' />
              </mat-form-field>
              <mat-autocomplete #stateAuto="matAutocomplete">
                <mat-option *ngFor="let state of states" [value]="state">
                  {{ state }}
                </mat-option>
              </mat-autocomplete>-->
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="test"
                  placeholder="Zip"
                  formControlName="Zip" />
              </mat-form-field>
            </div>
            <!-- phone & email -->
            <div class="form-field-container flex-row">
              <mat-form-field class="margin-right" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Phone"
                  pattern="(\(\d{3}\)?\s?\d{3}-?\d{4})|\+?(\d{11})|(\d{5})"
                  formControlName="Phone" />
                @if (showCustomError(['NewRequestor', 'Phone'], 'pattern')) {
                  <mat-hint class="hint-class">
                    Enter a valid phone number.
                  </mat-hint>
                }
              </mat-form-field>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="email"
                  placeholder="Email"
                  formControlName="Email" />
                @if (showCustomError(['NewRequestor', 'Email'], 'email')) {
                  <mat-hint class="hint-class">
                    Enter a valid email address.
                  </mat-hint>
                }
              </mat-form-field>
            </div>
          </fieldset>
        </div>
      </section>
      <section class="info-box">
        <h1 class="info-box-heading">Correspondence Content</h1>
        <div class="info-box-wrapper">
          <fieldset class="info-box-body">
            <div class="form-field-container flex-column">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Title &#42;"
                  formControlName="Title" />
                @if (showRequiredError(['Title'])) {
                  <mat-hint class="hint-class">
                    Please specify the correspondence subject or title.
                  </mat-hint>
                }
              </mat-form-field>
            </div>
            <div class="form-field-container flex-column">
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  type="text"
                  placeholder="Summary"
                  formControlName="Summary"></textarea>
                @if (showRequiredError(['Summary'])) {
                  <mat-hint class="hint-class">
                    Please specify the correspondence details.
                  </mat-hint>
                }
              </mat-form-field>
            </div>
            <div class="form-field-container flex-column">
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  type="text"
                  placeholder="Notes"
                  formControlName="Notes"></textarea>
              </mat-form-field>
            </div>
          </fieldset>
          <div class="info-box-btn flex-row-end">
            @if (submitAttempted && myForm.invalid) {
              <p class="submit-error" role="alert">
                Please correct the highlighted fields before submitting.
              </p>
            }
            @if (submitError) {
              <p class="submit-error" role="alert">{{ submitError }}</p>
            }
            <button
              class="btn-save"
              mat-raised-button
              type="submit"
              [disabled]="submitting">
              {{ submitting ? 'Submitting…' : 'Submit' }}
            </button>
            <button mat-raised-button type="button" (click)="goBack()">
              Cancel
            </button>
          </div>
        </div>
      </section>
    </form>
  </div>
</section>
